import withAlgoliaConnect from './algolia-art-connect'
import withAuth from './with-auth'

export {
  withAlgoliaConnect,
  withAuth
}